import React from 'react';
import { AuthRoles } from "components/auth";

export const CreditNoteConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/credit_note`,
            component: React.lazy(() => import('./CreditNote'))
        }
    ]
};